



const parameters = {
    clientId : process.env.VUE_APP_FED_CLIENT_ID,
    redirectUri : `${location.protocol}//${window.location.host}/accessToken/`,
    poslogApiUrl : process.env.VUE_APP_API_URL,
    xapikey : process.env.VUE_APP_X_API_KEY,
    xapikeyRef : process.env.VUE_APP_REF_X_API_KEY,
    refUrl : process.env.VUE_APP_REF_URL,
    poslogValidationUrl: process.env.VUE_APP_POSLOG_VALIDATION_URL,
    fedUrl : process.env.VUE_APP_FED_URL,
    showRawData : process.env.VUE_APP_SHOW_RAW_BTN.toLowerCase() == 'true'
};

export {
    parameters
}